import { createAction } from "@ngrx/store";
import { createCachedGetAction, createGetSuccessAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

const ACTION_PREFIX = "[Occupations]";
export const OCCUPATION_ACTION_TYPE = {
	getAll: `${ACTION_PREFIX} Get All`,
	getAllSuccess: `${ACTION_PREFIX} Get Success`,
	getAllFail: `${ACTION_PREFIX} Get AllFail`,
};

/**
 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(ContentServiceValue.GetOccupations) instead
 */
export namespace OccupationsAction {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(ContentServiceValue.GetOccupations) instead
	 */
	export const getAll = createCachedGetAction(createAction(OCCUPATION_ACTION_TYPE.getAll));

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(ContentServiceValue.GetOccupations) instead
	 */
	export const getAllSuccess = createGetSuccessAction(
		createAction(OCCUPATION_ACTION_TYPE.getAllSuccess, (occupations: Record<string, string>) => ({ occupations }))
	);

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(ContentServiceValue.GetOccupations) instead
	 */
	export const getAllFail = createAction(OCCUPATION_ACTION_TYPE.getAllFail, (error: AppError) => ({ error }));
}
